import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(({ shadows }) => ({
    tooltipWrapper: {
        boxShadow: shadows[24]
    }
}));
